import * as React from "react";
import { AppointmentStatus } from "../types";
import confirmation_sent from "../sms_texts/confirmation_sent.jpg";
import confirmed from "../sms_texts/confirmed.jpg";
import arrival_request from "../sms_texts/arrival_request.jpg";
import arrival_response from "../sms_texts/arrival_response.jpg";
import paperwork from "../sms_texts/paperwork.jpg";
import entrance from "../sms_texts/entrance.jpg";
import cancel_reply from "../sms_texts/cancel_reply.jpg";
import cancel_response from "../sms_texts/cancel_response.jpg";
import running_late_reply from "../sms_texts/running_late_reply.jpg";
import running_late_response from "../sms_texts/running_late_response.jpg";

interface OwnProps {
  smsStatus: AppointmentStatus;
  patientResponse: (status: AppointmentStatus) => void;
}

interface OwnState {}

type Props = OwnProps;

class SmsPresentation extends React.PureComponent<Props, OwnState> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    const { smsStatus, patientResponse } = this.props;
    return (
      <div className="sms-container">
        {smsStatus == AppointmentStatus.confirmation_request_sent && (
          <div className="fade">
            <img src={confirmation_sent} />
            <div className="buttons">
              <button onClick={() => patientResponse(AppointmentStatus.confirmed)}>1</button>
              <button onClick={() => patientResponse(AppointmentStatus.cancelled)}>2</button>
            </div>
          </div>
        )}
        {smsStatus == AppointmentStatus.confirmed && (
          <div className="fade">
            <img src={confirmed} />
          </div>
        )}
        {smsStatus == AppointmentStatus.arrival_response_sent && (
          <div className="fade">
            <img src={arrival_request} />
            <div className="buttons">
              <button onClick={() => patientResponse(AppointmentStatus.waiting)}>1</button>
              <button onClick={() => patientResponse(AppointmentStatus.late)}>2</button>
              <button onClick={() => patientResponse(AppointmentStatus.cancelled)}>3</button>
            </div>
          </div>
        )}
        {smsStatus == AppointmentStatus.waiting && (
          <div className="fade">
            <img src={arrival_response} />
          </div>
        )}
        {smsStatus == AppointmentStatus.paperwork && (
          <div className="fade">
            <img src={paperwork} />
          </div>
        )}
        {smsStatus == AppointmentStatus.entrance_request && (
          <div className="fade">
            <img src={entrance} />
          </div>
        )}
        {smsStatus == AppointmentStatus.cancelled && (
          <div className="fade">
            <img src={cancel_response} />
          </div>
        )}
        {smsStatus == AppointmentStatus.cancelled_response && (
          <div className="fade">
            <img src={cancel_reply} />
          </div>
        )}
        {smsStatus == AppointmentStatus.late && (
          <div className="fade">
            <img src={running_late_response} />
          </div>
        )}
        {smsStatus == AppointmentStatus.late_response && (
          <div className="fade">
            <img src={running_late_reply} />
            <div className="buttons">
              <button onClick={() => patientResponse(AppointmentStatus.waiting)}>1</button>
              <button onClick={() => patientResponse(AppointmentStatus.cancelled)}>2</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default SmsPresentation;
